import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
const LineCrudTableRowModal = ({el, i, ListClientsWhitLine,openModalVinculetedAlreadyExists,vinculedClient, getAmountClientsWhitoutLine}) => {

    let {code, name, lastName, numDocument/* ,mail,lines, _id */} = el;
    const handleChangeSelect = () => {
        
        
        if (ListClientsWhitLine.length) {
            openModalVinculetedAlreadyExists();
        }else{
            vinculedClient(numDocument);
            getAmountClientsWhitoutLine()
        }
    }

    /*if (lines>0) {
        //document.getElementById("#boton").style.className="visible";
        //document.getElementById('trama').classList.remove("d-none");

        let asd = document.getElementById('boton');
        console.log(asd);
                //.style.className="visible";
        //elemento.className="visible";
        {'btn btn-' + (form._id ? 'success' : 'primary')}
    }*/

    return (
        <tr key={code}>
            <th scope="row">{i + 1}</th>
            <td className="text-center">{name}</td>
            <td className="text-center">{lastName}</td>
            <td className="text-center">{numDocument}</td>
            <td className="text-center">
                <div>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Vincular Cliente</Tooltip>}>
                        <button type="button" 
                                className="btn btn-sm btn-info me-2"
                                onClick={handleChangeSelect}>
                            <i className="bi bi-pin-angle-fill"/>
                        </button>
                    </OverlayTrigger>
                </div>
                
            </td>
        </tr>
    );
}
export default LineCrudTableRowModal;
